import clsx from 'clsx';
import { CheckIcon } from '@heroicons/react/24/solid';

export interface IFormCheckboxProps {
  isSelected: boolean;
  onClick: () => void;
}

/**
 * -----------------------------------------------------------------------------
 * It renders the form checkbox with a selected state
 */
export function FormCheckbox({
  isSelected,
  onClick,
}: Readonly<IFormCheckboxProps>) {
  const className = isSelected
    ? 'border-gray-400 bg-green-50'
    : 'border-gray-300 bg-gray-50';

  return (
    <button
      className={clsx(
        'flex h-6 w-6 items-center justify-center rounded border p-px',
        className
      )}
      onClick={onClick}
      type="button"
    >
      {isSelected ? (
        <CheckIcon className="stroke-green-500 text-green-500" />
      ) : null}
    </button>
  );
}
